<template>
  <v-list-item @click.stop="dialog = true">
    <v-list-item-icon>
      <v-icon>mdi-information</v-icon>
    </v-list-item-icon>
    <v-list-item-content>Version</v-list-item-content>
    <v-dialog
      v-model="dialog"
      max-width="500"
    >
      <v-card>
        <v-card-title class="headline">Telestream GLIM version</v-card-title>
        <v-card-text>
          <div class="margin-top-one">
            <span class="bold paragraph-two">Number : </span>
            <span class="paragraph-two">{{ version }}</span>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-list-item>
</template>

<script>
import axios from 'axios'
import {ConnectionService} from "../../services/connection.service";

export default {
  name:  "Version",
  props: ['on'],
  data:  function () {
    return {
      dialog:  false,
      version: null
    }
  },
  mounted() {
    axios.get(ConnectionService.getUrl('/version'))
      .then(r => {
        this.version = r.data.version;
      })
  }
}
</script>

<style scoped>
</style>
